<ion-item class="form-element-wrapper" fill="outline" mode="md">
  <ion-input
    [label]="label"
    [labelPlacement]="labelPosition"
    [type]="type"
    [attr.pattern]="pattern"
    [formControl]="formCtrl"
    [required]="required"
    [autocapitalize]="capOption"
    [enterkeyhint]="enterkeyhint"
    [inputmode]="type"
    mode="ios"
    autocomplete="off"
    (keyup.enter)="keyupEnter.emit()"
    (ionInput)="input.emit($event)"
  >
  </ion-input>
  <fa-icon *ngIf="showPasswordIcon" slot="end" [icon]="showPasswordTextInd ? faEyeSlash : faEye" (click)="onClickPasswordIcon()"></fa-icon>
  <ion-note *ngIf="helper" slot="helper">{{ helper }}</ion-note>
</ion-item>
<mom-validation-text [formCtrl]="formCtrl"></mom-validation-text>
